import type { UiFeatureFlagNames } from "@/gql/graphql";
import { useFeatureFlags } from "./useFeatureFlags";

type FeatureFlaggedComponentProps = {
  flagName: UiFeatureFlagNames;
  children?: React.ReactNode;
  fallback?: React.ReactNode;
};

export const FeatureFlaggedComponent = ({
  flagName,
  children,
  fallback,
}: FeatureFlaggedComponentProps) => {
  const { canUseFeatureFlag } = useFeatureFlags();

  if (!canUseFeatureFlag(flagName)) {
    return fallback;
  }

  return children;
};
